/** 产品入口的唯一清单。报告内部的算法分项与 AI 辅助不再各自成为工具入口。 */
export const CORE_FEATURES = [
  {
    key: "literature", name: "文献检索", to: "/app/literature", icon: "search",
    material: "一个研究问题", short: "检索文献，查看来源与相关性",
    description: "用研究问题发起检索，查看文献题录与来源，按需用 AI 优化检索问题、评分和整理结果。",
    accept: "研究问题 / 关键词", example: "literature",
  },
  {
    key: "checkup", name: "论文与图片", to: "/app/checkup", icon: "stethoscope",
    material: "一篇论文和相关材料", short: "综合检查，形成一份报告",
    description: "上传 PDF、图片和原始数据，按实际材料检查图像、统计与文本信号，汇总需要复核的位置。",
    accept: "PDF / 图片 / Excel / CSV", example: "checkup",
  },
  {
    key: "data_check", name: "原始数据", to: "/app/data", icon: "table",
    material: "一份原始数据表", short: "回到原表，核对异常关系",
    description: "检查 Excel / CSV 中的重复记录、可推导列和异常规律，给出表名、行列与待核理由。",
    accept: "Excel / CSV / TSV", example: "data",
  },
] as const;

/** 核心操作与报告内可选加项。旧价格保留兼容账本，但不再宣传退出的功能。 */
export const PUBLIC_COST_KINDS = [
  "checkup", "scan", "data_check", "lit_brief", "interpret_image", "checkup_ask", "narrative_report",
] as const;

/** 已存核心结果可继续使用原报告页；其他历史结果交给统一只读页。 */
export function isCoreResultPath(path: string | null): boolean {
  if (!path || path.includes("\\") || [...path].some((char) => char.charCodeAt(0) <= 32)) return false;
  return /^\/app\/checkup\/[^/?#]+(?:[?#]|$)/.test(path)
    || /^\/app\/tools\/scan\/[^/?#]+(?:[?#]|$)/.test(path)
    || /^\/app\/data\?/.test(path) && new URLSearchParams(path.split("?")[1]).has("run");
}

export function historyResultPath(item: { source: string; id: string; open_path: string | null }): string {
  return isCoreResultPath(item.open_path)
    ? item.open_path!
    : `/app/history/${encodeURIComponent(item.source)}/${encodeURIComponent(item.id)}`;
}

/** 只读叙事报告由记录 id 定位，不信任 payload 中任意 URL。 */
export function narrativeReportPath(source: string, id: string): string | null {
  return source === "narrative" && /^[A-Za-z0-9_-]+$/.test(id)
    ? `/api/narrative-report/${encodeURIComponent(id)}.html`
    : null;
}
